import styled from "styled-components";

export const StickyLogoContainer = styled.div`
    position: absolute;
    left: ${props => (props?.left ? `${props?.left}px` : '0px')};
    z-index: 1;
    display: ${props => (props?.show ? 'block' : 'none')};
    animation-timing-function: ease-in-out;
    padding: 10px;
`